import ServiceMessage from './ServiceMessage';
export * from './ServiceMessage';
export default ServiceMessage;
